import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { IFieldGroupItem, boStyle } from 'constants/content.constants';
import { MultiLangTable } from './MultiLangTable';
import { SingleLangTable } from './SingleLangTable';

interface IProps {
	section: any;
	style: string;
	selectedLanguage?: any;
}

export const Section = ({ section, style, selectedLanguage }: IProps) => {
	const [tableHeaderItems, setTableHeaderItems] = useState([section?.additionalTitle] || '');

	useEffect(() => {
		const uniqueFieldGroupItems: any = [];
		section?.fieldGroups?.map((fieldGroup: any) => {
			fieldGroup?.fieldGroupItems?.map((fieldGroupItem: IFieldGroupItem) => {
				if (!uniqueFieldGroupItems?.includes(fieldGroupItem?.displayTitle)) {
					uniqueFieldGroupItems?.push(fieldGroupItem?.displayTitle);
				}
			});
		});
		setTableHeaderItems([...tableHeaderItems, ...uniqueFieldGroupItems]);
	}, []);

	return (
		<Box>
			<Typography variant="h6">{section?.displayTitle || ''}</Typography>
			{style === boStyle.SINGLE_LANGUAGE_PAGE ? (
				<SingleLangTable
					section={section}
					selectedLanguage={selectedLanguage}
					tableHeaderItems={tableHeaderItems}
				/>
			) : (
				<MultiLangTable section={section} tableHeaderItems={tableHeaderItems} />
			)}
		</Box>
	);
};
